import { runGateCore, type GateOptions, type GateResult } from "./securityGateCore";

export async function militaryGradeClientGateAgainstSuspiciousOrSeditiousFiles(
  file: File,
  options?: GateOptions,
): Promise<GateResult> {
  // Try worker; on any failure or timeout, fall back to main thread.
  try {
    if (typeof window !== "undefined" && typeof Worker !== "undefined") {
      const worker = new Worker(new URL("./securityGate.worker.ts", import.meta.url), {
        type: "module",
      });

      const res: GateResult = await new Promise((resolve) => {
        const timer = setTimeout(() => {
          try {
            worker.terminate();
          } catch {
            //
          }
          resolve({ ok: false, reason: "worker_timeout", message: "Validation timed out." });
        }, (options?.timeoutMs ?? 6000) + 500);

        worker.onmessage = (e) => {
          clearTimeout(timer);
          try {
            worker.terminate();
          } catch {
            //
          }
          resolve(e.data as GateResult);
        };
        worker.onerror = () => {
          clearTimeout(timer);
          try {
            worker.terminate();
          } catch {
            //
          }
          resolve({ ok: false, reason: "worker_error", message: "Worker error." });
        };

        worker.postMessage({ file, options });
      });

      // ✅ Narrow before accessing `reason`
      if (
        !res.ok &&
        "reason" in res &&
        (res.reason === "worker_timeout" || res.reason === "worker_error")
      ) {
        // soft fallback to main thread
        return await runGateCore(file, options);
      }
      return res;
    }
  } catch {
    // spawn/URL failures → fallback
  }
  return await runGateCore(file, options);
}
